"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndeterminateBar = exports.CheckOuter = exports.CheckHidden = void 0;

var _context = require("../../context");

var _utils = require("../../utils");

var _constants = require("../constants");

var CheckHidden = (0, _context.styledWithTheme)('input')(function (_ref) {
  var disabled = _ref.disabled;
  return {
    position: 'relative',
    top: 0,
    left: 0,
    opacity: 0,
    display: 'block',
    margin: 0,
    width: (0, _utils.px)(_utils.A11Y_INLINE_MIN_SIZE),
    height: (0, _utils.px)(_utils.A11Y_INLINE_MIN_SIZE),
    zIndex: 1,
    cursor: disabled ? 'not-allowed' : 'pointer'
  };
});
exports.CheckHidden = CheckHidden;
var CheckOuter = (0, _context.styledWithTheme)('div')({
  width: (0, _utils.px)(_utils.A11Y_INLINE_MIN_SIZE),
  height: (0, _utils.px)(_utils.A11Y_INLINE_MIN_SIZE),
  position: 'relative',
  display: 'flex',
  flexShrink: 0
});
exports.CheckOuter = CheckOuter;
var IndeterminateBar = (0, _context.styledWithTheme)('div')({
  position: 'absolute',
  opacity: 0,
  height: (0, _utils.px)(_constants.INDETERMINATE_BAR_HEIGHT),
  width: (0, _utils.px)(_constants.INDETERMINATE_BAR_WIDTH),
  borderRadius: _constants.INDETERMINATE_BAR_HEIGHT,
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  'input:indeterminate + &': {
    opacity: 1
  }
});
exports.IndeterminateBar = IndeterminateBar;